export const ATTACH_POLICY_REQUEST = "ATTACH_POLICY_REQUEST";
export const ATTACH_POLICY_SUCCESS = "ATTACH_POLICY_SUCCESS";
export const ATTACH_POLICY_FAILURE = "ATTACH_POLICY_FAILURE";
export const GET_ATTACHED_POLICIES_REQUEST = "GET_ATTACHED_POLICIES_REQUEST";
export const GET_ATTACHED_POLICIES_SUCCESS = "GET_ATTACHED_POLICIES_SUCCESS";
export const GET_ATTACHED_POLICIES_FAILURE = "GET_ATTACHED_POLICIES_FAILURE";
export const CLEAR_ATTACH_POLICY_DATA = "CLEAR_ATTACH_POLICY_DATA";
